$(function() {
    var rules = {};

    $('[name*="phone"]').each(function() {
        rules[this.name] = {
            phone: true
        }
    });

    $("[name*=\"post_code\"]").each(function() {
        rules[this.name] = {
            number: true
        }
    });

    $('.js-account-branches').validate({
    	rules: rules,
        submitHandler: function(form) {
            form.submit();
        }
    });

    $('.js-account-branch-modal').validate({
    	rules: rules,
        submitHandler: function(form) {
            form.submit();
        }
    });
});